import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_SUBCATEGORIES_APP_ROOT = `${BASE_ADMIN_V2_PATH}/subcategories`;

export const ADMIN_SUBCATEGORIES_APP_PATHS = {
  SUBCATEGORIES_LIST: `${ADMIN_SUBCATEGORIES_APP_ROOT}`,
};
